import React, { useState } from "react";
import "../style/MyCarBoletin.css";

function formatNumberWithCommas(number) {
  if (number === undefined || number === null || number === "") return "0";
  return Number(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function CarBoletin({ carro, onSelectionChange }) {
  const imageUrl = (carro.imagenes?.[0] || "").replace("http://", "https://");
  const [checked, setChecked] = useState(false);

  const isOnSale =
    Boolean(carro.offerta) && Number(carro.precioOferta) > 0;

  const setSelection = (next) => {
    if (next === checked) return;
    setChecked(next);
    onSelectionChange(carro, next);
  };

  const handleRowClick = () => {
    setSelection(!checked);
  };

  const handleCheckboxChange = (event) => {
    setSelection(event.target.checked);
  };

  return (
    <div
      className={`bp-row${checked ? " is-selected" : ""}`}
      onClick={handleRowClick}
    >
      <input
        type="checkbox"
        className="bp-checkbox"
        checked={checked}
        onChange={handleCheckboxChange}
        onClick={(e) => e.stopPropagation()}
        aria-label={`Seleccionar ${carro.marca} ${carro.modelo}`}
      />
      {imageUrl ? (
        <img className="bp-thumb" src={imageUrl} alt={carro.modelo} />
      ) : (
        <div className="bp-thumb" />
      )}
      <div className="bp-info">
        <div className="bp-title-row">
          <p className="bp-title">
            {carro.marca} {carro.modelo} {carro.anio}
          </p>
          {carro.lote && carro.lote !== "0" && (
            <span className="bp-lote">Lote {carro.lote}</span>
          )}
        </div>
        <div className="bp-specs">
          {carro.millaje !== undefined && carro.millaje !== 0 && (
            <span className="bp-spec">
              <strong>Millaje:</strong>
              {formatNumberWithCommas(carro.millaje)}
            </span>
          )}
          {carro.motor && carro.motor !== "0" && (
            <span className="bp-spec">
              <strong>Motor:</strong>
              {carro.motor}
            </span>
          )}
          {carro.combustible && carro.combustible !== "N/A" && (
            <span className="bp-spec">
              <strong>Combustible:</strong>
              {carro.combustible}
            </span>
          )}
        </div>
      </div>
      <div className="bp-prices">
        <span className="bp-price-label">
          {isOnSale ? "Oferta" : "Precio"}
        </span>
        <span
          className={`bp-price${isOnSale ? " bp-oferta" : ""}`}
          translate="no"
        >
          L.{formatNumberWithCommas(isOnSale ? carro.precioOferta : carro.precio)}
        </span>
        {isOnSale && (
          <span className="bp-price bp-price--strike" translate="no">
            L.{formatNumberWithCommas(carro.precio)}
          </span>
        )}
      </div>
    </div>
  );
}

export default CarBoletin;
